import { render, staticRenderFns } from "./GodList.vue?vue&type=template&id=138de307&scoped=true&"
import script from "./GodList.vue?vue&type=script&lang=js&"
export * from "./GodList.vue?vue&type=script&lang=js&"
import style0 from "./GodList.vue?vue&type=style&index=0&id=138de307&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138de307",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138de307')) {
      api.createRecord('138de307', component.options)
    } else {
      api.reload('138de307', component.options)
    }
    module.hot.accept("./GodList.vue?vue&type=template&id=138de307&scoped=true&", function () {
      api.rerender('138de307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/God/GodList.vue"
export default component.exports